<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Controleren"
      @next-step="$router.push({ name: 'checkOutConfirm' })"
      @prev-step="goToPrevStep"
    ></next-prev-menu>
    <invoice
      :orderDetails="orderDetails"
      :shop="shop"
      @setQuote="setQuote"
      @updateOrder="updateOrder"
      @updateProject="updateProject"
    ></invoice>
  </div>
</template>

<script>
/**
 * Invoiceaddress component
 *
 * Properties:
 *
 * - address : invoiceAddress object = optional
 * - shop : shop {}
 * - hideSubCard : Boolean to hide contact subCard

 *
 */

import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import Invoice from '@/components/Invoice.vue'

export default {
  data() {
    return {
      cardBack: '',
      flipped: false,
      addresses: [],
      orderType: 'invoice',
      editType: '',
      formatString: '',
      projectName: '',
      reference: '',
      projectFormat: new RegExp(),
      newProjectInvalid: false,
      newReferenceInvalid: false
    }
  },
  components: {
    NextPrevMenu,
    Invoice
  },
  methods: {
    goToPrevStep() {
      const prevRoute = this.checkOutStore.deliveryAddressIncludedInFiles
        ? 'checkOutCart'
        : 'checkOutDeliver'
      this.$router.push({ name: prevRoute })
    },
    setQuote(val) {
      this.checkOutStore.updateOrderDetails('quotationNo', val)
    },
    updateOrder(val) {
      this.checkOutStore.updateOrderDetails(val[0], val[1])
    },
    updateProject(project) {
      this.checkOutStore.updateProject({
        name: project.name || '',
        id: project.id || 0
      })
    }
  },
  computed: {
    ...mapStores(useCheckOutStore),
    custom() {
      return this.rootStore.theme.customFields
    },
    orderDetails() {
      return this.checkOutStore.orderDetails
    },
    shop() {
      return this.checkOutStore.shop
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.card {
  height: 590px;
}
</style>
